import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Dress = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.968 19.08c0-8.07-5.515-10.487-5.515-10.487 0-1.347 1.715-3.244 2.408-3.957a.5.5 0 0 0 .042-.626l-.581-.816a.45.45 0 0 0-.177-.15.4.4 0 0 0-.223-.039 4.2 4.2 0 0 0-1.661.645 4.6 4.6 0 0 0-1.293 1.293 4.6 4.6 0 0 0-1.293-1.295 4.2 4.2 0 0 0-1.66-.646.4.4 0 0 0-.224.039.45.45 0 0 0-.176.15l-.58.815a.5.5 0 0 0 .042.627c.693.712 2.408 2.61 2.408 3.956 0 0-5.515 2.416-5.515 10.488m13.998 0c0 .499-.184.977-.512 1.33-.329.353-.774.55-1.238.55a1.7 1.7 0 0 1-1.237-.55 1.96 1.96 0 0 1-.513-1.33c0 .499-.184.977-.513 1.33a1.7 1.7 0 0 1-1.237.55 1.7 1.7 0 0 1-1.238-.55 1.96 1.96 0 0 1-.512-1.33c.005.25-.036.5-.122.732a1.9 1.9 0 0 1-.376.625c-.163.18-.358.322-.573.419a1.65 1.65 0 0 1-1.357 0 1.75 1.75 0 0 1-.573-.419 1.9 1.9 0 0 1-.377-.625 2 2 0 0 1-.121-.732c0 .499-.185.977-.513 1.33a1.7 1.7 0 0 1-1.238.55 1.7 1.7 0 0 1-1.237-.55 1.96 1.96 0 0 1-.513-1.33"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Dress) as SvgIcon;
export { ForwardRef as ReactComponent };
